/**
 * TanStack Query is the only store for server data (§12.2) — there is no Redux, and no derived
 * value is ever cached client-side.
 */

import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../api/client';

/** One retry for transient failures; 4xx answers are final and are not retried. */
const MAX_QUERY_RETRIES = 1;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // §11.2: status and lists are re-read when the tab regains focus.
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < MAX_QUERY_RETRIES;
      },
      staleTime: 15_000,
      gcTime: 5 * 60_000,
    },
    mutations: {
      retry: false,
    },
  },
});
